import { render, staticRenderFns } from "./WfConsumerRecordForm.vue?vue&type=template&id=4f79701a&"
import script from "./WfConsumerRecordForm.vue?vue&type=script&lang=js&"
export * from "./WfConsumerRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports